import React from "react";
import {
  
  FaTwitter,
  FaWhatsapp,
  FaTelegram,
  FaInstagram,
} from "react-icons/fa";

const SideNav = () => {
  return (
    <>
      <ul className="flex justify-center items-center flex-col">
        <li className="inline-block my-3 border social-link  rounded-full">
          <a href="#" target="_blank">
            <FaWhatsapp className="text-2xl transition-all" />
          </a>
        </li>
        <li className="inline-block my-3 social-link  rounded-full">
          <a href="#" target="_blank">
            <FaTelegram className="text-2xl transition-all" />
          </a>
        </li>
        
        <li className="inline-block my-3 social-link  rounded-full">
          <a href="#" target="_blank">
            <FaInstagram className="text-2xl transition-all" />
          </a>
        </li>
        <li></li>
      </ul>
    </>
  );
};

export default SideNav;